export default __webpack_public_path__ + "static/mob-img04-e2b7a0119206c1e5ca2067e64c8ed86c.png";